import { t } from "i18next";
import React, { memo } from "react";
import useChooseTicket from "../../../../hooks/useChooseTicket";
import { useLanguage } from "../../../../hooks/useLanguage";
import BaseImage from "../../../baseImage/BaseImage";
import BaseButton from "../../../button/BaseButton";
import AddTicketRow from "../../actionBuyTicket/AddTicketRow";
import HeaderListTableBuyTicket from "../../actionBuyTicket/HeaderListTableBuyTicket";
import TicketsAdded from "../../actionBuyTicket/TicketsAdded";
import TicketsAddedMobile from "../../rowTicketQuantity";
import ChooseYourTicketLoading from "../../skeletonLoading/ChooseYourTicketLoading";
import TitleTicket from "../../tickets/TitleTicket";
import TotalPrice from "../../tickets/TotalPrice";

function ChooseYourTicket({
  onNextStep,
  eventId,
  dataOrder,
  ticketTypes,
  isLoadingFetchTicketType,
  onFetchTicketByEvent,
  oldOrder,
  setOldOrder,
  isLoadingSetOldOrder,
  onGetOldOrder,
  timeHadOrder,
  handleCancelOrder,
}) {
  const {
    onCreateOrder,
    isLoadingCreateOrder,
    dataTicketForCreateOrder,
    isLoadingCancelOrder,
    // handleCancelOrder,
  } = useChooseTicket({
    eventId,
    onNextStep,
    onFetchTicketByEvent,
    setOldOrder,
    oldOrder,
    onGetOldOrder,
  });

  const { currentLanguage, nameWithLanguage } = useLanguage();
  if (isLoadingFetchTicketType || isLoadingSetOldOrder)
    return (
      <div className="w-full">
        <ChooseYourTicketLoading />
      </div>
    );

  // const timeHadOrder =
  //   oldOrder?.isExist && currentLanguage === "en"
  //     ? `${orderCountDown.displayMinutes} : ${orderCountDown.displaySeconds}`
  //     : `${orderCountDown.displaySeconds} : ${orderCountDown.displayMinutes}`;
  const orderTicketType = ticketTypes.sort((a, b) =>
    a[nameWithLanguage].localeCompare(b[nameWithLanguage])
  );

  return (
    <div className="flex flex-col w-full px-4 pt-10 pb-10 bg-white border rounded-lg lg:px-10">
      <div className="w-full max-h-[300px]  md:max-h-[400px] lg:max-h-[750px] h-[calc((100vw_-_60px)/1.5)] lg:h-[400px]">
        <BaseImage className="" src={dataOrder?.ticketTypeImage} />
      </div>
      {/* {orderTicketType?.length > 0 ? (
        <div className="flex items-center justify-center w-full pt-8 pb-12">
          <div className="grid grid-cols-6 px-20 gap-y-4 md:grid-cols-12 gap-x-6 md:gap-y-8">
            {orderTicketType.map((ticket, index) => {
              return (
                <TitleTicket ticket={ticket} key={ticket?.id} index={index} />
              );
            })}
          </div>
        </div>
      ) : (
        <div className="pb-6" />
      )} */}
      <div className="h-8" />

      {oldOrder?.isExist && (
        <div>
          <div className="text-neutral-600 text-body-1 md:text-title-2">
            {t("title_order_pending")}
            <p className="block font-bold text-center text-purple-500 md:text-title-1 md:px-1 md:inline text-title-2">
              {timeHadOrder}
            </p>
          </div>
          <div className="flex flex-row gap-x-2.5 px-6 py-4 text-justify bg-fourth-950 rounded mt-4 mb-12">
            <p className="text-fourth-900 text-body-2 md:text-body-1">*Note:</p>
            <p className="text-fourth-900 text-body-2 md:text-body-1">
              {t("description_order_pending")}
            </p>
          </div>
        </div>
      )}

      {/* </div> */}
      <div className="flex flex-col pb-4 gap-y-4 md:hidden md:pb-0">
        <TicketsAddedMobile isHadOldOrder={oldOrder?.isExist} />
      </div>
      {/* ..>>>>>>>>>>>>>>>>>>>> */}
      <div
        className={`${
          oldOrder?.isExist ? "hidden" : ""
        } flex flex-col gap-2 px-3 py-4 border rounded-lg border-primary-200 md:px-0 md:py-0 md:flex md:flex-col md:border-none `}
      >
        <div className="relative flex flex-row w-full pb-4 md:flex-col">
          <HeaderListTableBuyTicket />
          <div className="flex flex-col gap-2 w-[150%] md:w-full">
            <div className="flex flex-col gap">
              <TicketsAdded isHadOldOrder={oldOrder?.isExist} />
              <div className={`${oldOrder?.isExist ? "hidden" : ""}`}>
                <AddTicketRow ticketTypes={ticketTypes} />
              </div>
            </div>
          </div>
        </div>
        <div className="h-10 md:h-0" />
      </div>

      <TotalPrice />
      <div
        className={`md:flex-row md:flex ${
          oldOrder?.isExist ? "md:gap-x-6 lg:justify-end" : ""
        }`}
      >
        {oldOrder?.isExist && (
          <div className="flex justify-end w-full pt-6 lg:w-auto ">
            <div className={`w-full md:w-full lg:w-auto`}>
              <BaseButton
                disable={
                  oldOrder?.isExist
                    ? false
                    : isLoadingCancelOrder || isLoadingCreateOrder
                }
                onClick={handleCancelOrder}
                sizeButton="md"
                variant="outline"
                className="py-2.5 px-5 lg:px-8"
                isLoading={true}
              >
                <p className="font-bold text-purple-500 text-body-2 lg:text-body-1">
                  {t("cancel_order")}
                </p>
              </BaseButton>
            </div>
          </div>
        )}

        <div
          className={`flex justify-end w-full pt-6 ${
            oldOrder?.isExist ? "lg:w-auto" : ""
          }`}
        >
          <div
            className={`w-full ${
              oldOrder?.isExist ? "md:w-full lg:w-auto" : " md:w-auto"
            }`}
          >
            <BaseButton
              disable={
                oldOrder?.isExist
                  ? false
                  : isLoadingCancelOrder ||
                    isLoadingCreateOrder ||
                    dataTicketForCreateOrder?.length <= 0
              }
              onClick={onCreateOrder}
              sizeButton="md"
              variant="filled"
              className="py-2.5 px-5 lg:px-8"
              isLoading={true}
            >
              <p className="font-bold text-white text-body-2 lg:text-body-1">
                {t("check_out")}
              </p>
            </BaseButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(ChooseYourTicket);
